module.exports = __webpack_public_path__ + "img/20251028.c7cc73d5.jpg";